<div class="padding">
  @if (dataLoading()) {
    <app-loading-animation></app-loading-animation>
  }

  @if (dataAvailable() || dataEmpty()) {
    <app-table-template
      tableTitle="Entities"
      [showTitle]="true"
      [showSearch]="true"
      [showToggle]="true"
      [hasCardView]="true"
      [showPagination]="true"
      [clickableRows]="true"
      [columns]="columns()"
      [currentPage]="currentPage()"
      [sortedOn]="sortField()"
      [sortDescending]="sortOrder() === -1"
      [tableMinWidthInRem]="165"
      (sortChanged)="sort($event)"
      (searchChanged)="search($event)"
      (pageChanged)="page($event)"
      (rowClicked)="rowClicked($event)">
      <app-tile [currentPage]="currentPage()"></app-tile>
    </app-table-template>
  }
</div>
